'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputRedux = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  input {\n    appearance: none;\n    background-color: ', ';\n    border: 2px solid ', ';\n    border-radius: ', ';\n    color: inherit;\n    font-size: 1rem;\n    height: ', ';\n    padding: ', ';\n    vertical-align: middle;\n    box-shadow: inset 0 2px 3px ', ';\n    width: 100%;\n    margin-bottom: ', ';\n\n    &:disabled {\n      background-color: ', ';\n    }\n\n    &:focus {\n      box-shadow: inset 0 2px 3px ', ';\n      border-color: ', ';\n      outline: 0;\n    }\n\n    ', ' ', ';\n  }\n'], ['\n  input {\n    appearance: none;\n    background-color: ', ';\n    border: 2px solid ', ';\n    border-radius: ', ';\n    color: inherit;\n    font-size: 1rem;\n    height: ', ';\n    padding: ', ';\n    vertical-align: middle;\n    box-shadow: inset 0 2px 3px ', ';\n    width: 100%;\n    margin-bottom: ', ';\n\n    &:disabled {\n      background-color: ', ';\n    }\n\n    &:focus {\n      box-shadow: inset 0 2px 3px ', ';\n      border-color: ', ';\n      outline: 0;\n    }\n\n    ', ' ', ';\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var InputStyled = _styledComponents2.default.div(_templateObject, function (props) {
  return props.theme.bahFormInputBackgroundColor;
}, function (props) {
  return props.theme.bahFormInputBorderColor;
}, function (props) {
  return props.theme.bahFormFieldsDefaultBorder;
}, function (props) {
  return props.theme.bahFormInputDefaultHeight;
}, function (props) {
  return props.theme.bahFormInputDefaultPadding;
}, function (props) {
  return props.theme.bahFormInputBoxShadowColor;
}, function (props) {
  return props.theme.bahFormFieldsDefaultMarginBottom;
}, function (props) {
  return props.theme.bahFormInputDisabledColor;
}, function (props) {
  return props.theme.bahFormInputFocusShadowColor;
}, function (props) {
  return props.theme.bahFormInputFocusBorderColor;
}, function (props) {
  return props.isValid && '\n      box-shadow:inset 0 2px 3px ' + props.theme.bahColors.green100 + ';\n      border-color: ' + props.theme.bahColors.green300 + ';\n      outline: 0;\n      &:focus {\n        box-shadow:inset 0 2px 3px ' + props.theme.bahColors.green200 + ';\n        border-color: ' + props.theme.bahColors.green400 + ';\n        outline: 0;\n      }\n    ';
}, function (props) {
  return props.isInvalid && '\n      box-shadow:inset 0 2px 3px ' + props.theme.bahColors.red100 + ';\n      border-color: ' + props.theme.bahColors.red300 + ';\n      outline: 0;\n      &:focus {\n        box-shadow:inset 0 2px 3px ' + props.theme.bahColors.red200 + ';\n        border-color: ' + props.theme.bahColors.red400 + ';\n        outline: 0;\n      }\n    ';
});

var Input = function Input(_ref) {
  var children = _ref.children,
      name = _ref.name,
      type = _ref.type,
      disabled = _ref.disabled,
      isValid = _ref.isValid,
      isInvalid = _ref.isInvalid,
      props = _objectWithoutProperties(_ref, ['children', 'name', 'type', 'disabled', 'isValid', 'isInvalid']);

  return _react2.default.createElement(
    InputStyled,
    { isValid: isValid, isInvalid: isInvalid },
    _react2.default.createElement(
      'label',
      { htmlFor: name },
      children
    ),
    _react2.default.createElement('input', _extends({}, props, { disabled: disabled, type: type, name: name }))
  );
};

var InputRedux = function InputRedux(_ref2) {
  var disabled = _ref2.disabled,
      isValid = _ref2.isValid,
      isInvalid = _ref2.isInvalid,
      props = _objectWithoutProperties(_ref2, ['disabled', 'isValid', 'isInvalid']);

  return _react2.default.createElement(
    InputStyled,
    { isValid: isValid, isInvalid: isInvalid },
    _react2.default.createElement(
      'label',
      { htmlFor: props.input.name },
      props.label
    ),
    _react2.default.createElement('input', _extends({}, props.input, {
      placeholder: props.placeholder,
      readOnly: props.readOnly,
      type: props.type,
      disabled: disabled
    }))
  );
};

exports.InputRedux = InputRedux;
Input.defaultProps = {
  children: '',
  name: '',
  type: 'text',
  disabled: false,
  isValid: false,
  isInvalid: false
};

Input.propTypes = {
  children: _propTypes2.default.node.isRequired,
  name: _propTypes2.default.string,
  type: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  isValid: _propTypes2.default.bool,
  isInvalid: _propTypes2.default.bool
};

InputRedux.defaultProps = {
  name: '',
  label: '',
  input: {},
  placeholder: '',
  type: 'text',
  readOnly: false,
  disabled: false,
  isValid: false,
  isInvalid: false
};

InputRedux.propTypes = {
  name: _propTypes2.default.string,
  label: _propTypes2.default.string,
  input: _propTypes2.default.object,
  placeholder: _propTypes2.default.string,
  type: _propTypes2.default.string,
  readOnly: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  isValid: _propTypes2.default.bool,
  isInvalid: _propTypes2.default.bool
};

exports.default = Input;


//////////////////
// WEBPACK FOOTER
// ./~/@rafacdb/bah/lib/Input.js
// module id = 103
// module chunks = 0